<!--评论的公共组件-->
<template>
    <div style="padding:5px;">
        <div class="comment-block">
            <img data-width="88" data-height="88" class="avatar"
                 src="//cdn.kesci.com/images/avatar/11.jpg?imageView2/2/w/88/h/88">
            <div class="input-block">
                <Input type="textarea" :rows="4" v-model="submitData.comment" maxlength="200" placeholder="Enter something..."/>
                <Button type="primary" style="margin-top:10px;" v-html="commentButtonName" @click="submit"></Button>
                <span class="ref-post-info" v-if="replyShow" style="float:right;padding-top:15px;">
                    回复 <a>{{currentReplyName}}</a> <a class="action-link"><i
                        class="ivu-icon ivu-icon-close-round"></i></a>
                    <a class="action-link" @click="closeReply">
                        <Icon type="md-close"/>
                    </a>
                </span>
            </div>
        </div>
        <div class="comment-list">
            <ul class="demo-spin-container" >
                <!-- 加载条 -->
                <Spin fix v-if="loading"></Spin>
                <li v-for="item in commentsList">
                    <img data-width="88" data-height="88" class="avatar"
                         src="https://cdn.kesci.com/upload/image/q9k1w788vx.jpg?imageView2/2/w/88/h/88">
                    <div class="comment-content">
                        <div class="userinfo-wrapper">
                            <div class="userinfo">
                                            <span class="username">
                                                {{item.user_info.name}}
                                            </span>
                                <span class="text-fade"> · {{formatDt(item.ctime)}} </span>
                            </div>
                            <div class="action hidden-xxs" style="margin-top: 0px; padding-top: 4px;">
                                <a @click="reply(item.id,item.user_info.name)" style="float:right;">回复</a>
                                <p></p>
                                <a @click="deleteComments(item.id)" v-if="user_info.id == item.user_info.uid" style="float:right;" >删除</a>
                            </div>
                        </div>


                        <p class="ref-post-info" v-if="item.reply_user_info ">
                            回复 <a v-html="item.reply_user_info.name"></a>
                        </p>

                        <div class="markdown-body comment-body" v-html="item.comment"></div>
                    </div>
                </li>
            </ul>
            <br />

            <Page :total="total" :page-size="pageSize" @on-change="pageChange" show-total size="small" />
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import moment from 'moment'
    export default {
        name:"comments",
        props:{
            loading:{
                type:Boolean,
                required:true,
                default:false,
            },
            commentsList:{
                type:Array,
                required: true
            },
            pageNum:{
                type:Number,
                required:true,
            },
            pageSize:{
                type:Number,
                required:true,
            },
            total:{
                type:Number,
                required:true,
            },
            pageChange:{
                type:Function,
                required:true,
            },
            submitComments:{
                type:Function,
                required:true,
            },
            deleteComments:{
                type:Function,
                required:true,
            }

        },
        data(){
            return {
                submitData:{
                    reply_id:0,
                    comment:'',
                },
                replyShow: false,
                currentReplyName: "",
                commentButtonName: "发布",
            }
        },
        methods:{
            formatDt(dt){
                return moment(dt).format('YYYY-MM-DD HH:mm:ss')
            },
            reply(id, authorName) {
                this.replyShow = true;
                this.submitData.reply_id = id;
                this.currentReplyName = authorName;
                this.commentButtonName = "回复";

            },
            closeReply() {
                this.replyShow = false;
                this.currentReplyName = "";
                this.commentButtonName = "发布";
            },
            // 提交评论
            submit(){
                if(this.submitData.comment == ""){
                    this.$Message.error("评论内容不能为空");
                    return false;
                }else{
                    this.submitComments(this.submitData)
                    // 重置提交内容
                    this.submitData.comment = '';
                    this.submitData.reply_id = 0;
                    this.currentReplyName = '';
                    this.replyShow = false;
                    this.commentButtonName = '发布';
                }
            }
        },
        computed:{
        ...mapState({
                user_info: state => state.loginState.user_info,
            })
        }
    }
</script>
<style scoped lang="less">

    .demo-spin-container{
        position: relative;
    }

    .comment-list {
        padding-left: 48px;
    }

    .comment-block {
        -ms-flex-align: start;
        align-items: flex-start;
        display: -ms-flexbox;
        display: flex;
        margin-top: 12px;
        padding-bottom: 12px;
    }

    .comment-list li {
        border-top: 1px solid #f5f5f5;
        -ms-flex-align: start;
        align-items: flex-start;
        display: -ms-flexbox;
        display: flex;
        font-size: 12px;
        padding: 20px 0;
    }

    .comment-list .avatar {
        display: block;
        -ms-flex-positive: 0;
        flex-grow: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;
    }

    .comment-content {
        width: 100%;
    }

    .comment-list li .action {
        font-size: 13px;
        margin-top: 6px;
        text-align: right;
    }

    .comment-list li .userinfo-wrapper {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-pack: justify;
        justify-content: space-between;
    }

    .input-block {
        flex-grow: 1;
    }

    .avatar {
        display: block;
        -ms-flex-positive: 0;
        flex-grow: 0;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;
    }
</style>
